import { render, staticRenderFns } from "./BaseCancelButton.vue?vue&type=template&id=1be14c7f&scoped=true&lang=pug"
import script from "./BaseCancelButton.vue?vue&type=script&lang=ts"
export * from "./BaseCancelButton.vue?vue&type=script&lang=ts"
import style0 from "./BaseCancelButton.vue?vue&type=style&index=0&id=1be14c7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be14c7f",
  null
  
)

export default component.exports